import { makeStyles } from '@material-ui/core/styles';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import type { StandardDivProps } from '@sprinx/react-mui-components';
import React from 'react';
import useTranslateWithFallback from '../../hooks/useTranslateWithFallback';

export type ProductDetailCanceledStatusClassKey = 'root';

const themeSettings = { name: 'ProductDetailCanceledStatus' };
const useStyles = makeStyles(
  (theme) => ({
    root: {
      color: theme.palette.error.main,
      fontWeight: theme.typography.fontWeightRegular,
    },
  }),
  themeSettings,
);

const ProductDetailCanceledStatus = React.forwardRef<
  HTMLAnchorElement,
  StandardDivProps<ProductDetailCanceledStatusClassKey>
>(({ children, className, classes: pClasses, ...rest }, ref) => {
  const classes = useStyles({ classes: pClasses });
  const t = useTranslateWithFallback();

  return (
    <span ref={ref} className={classes.root} {...rest}>
      {t('app/products/canceled')}
    </span>
  );
});

ProductDetailCanceledStatus.displayName = 'ProductDetailCanceledStatus';

export default withThemeProps(themeSettings)(ProductDetailCanceledStatus);
